import { render, staticRenderFns } from "./AuthTabs.vue?vue&type=template&id=0180414a&scoped=true"
import script from "./AuthTabs.vue?vue&type=script&lang=js"
export * from "./AuthTabs.vue?vue&type=script&lang=js"
import style0 from "./AuthTabs.vue?vue&type=style&index=0&id=0180414a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0180414a",
  null
  
)

export default component.exports